import React from "react";
import NormalDetailed from "./NormalDetailed/NormalDetailed";
import NormalMinimised from "./NormalMinimised/NormalMinimised";
import NewMember from "./NewMember/NewMember";

const InnerText = ({ myId, efficeData, ppl, subEfficeView }) => {
  switch (subEfficeView) {
    case "normalDetailed":
      return <NormalDetailed myId={myId} efficeData={efficeData} ppl={ppl} />;
    case "normalMinimised":
      return <NormalMinimised efficeData={efficeData} ppl={ppl} />;
    case "newMember":
      return <NewMember efficeData={efficeData} ppl={ppl} />;
    default:
      return null;
  }
};

export default InnerText;
